// extracted by mini-css-extract-plugin
export default {"container":"component_form_language_container__B8xyl","description":"component_form_language_description__4oGXL"};